{
  "menu": {
    "home": "首页",
    "programs": "项目",
    "residency": "投资居留",
    "citizenship": "护照 & 公民身份",
    "about": "关于我们",
    "aboutShort": "关于",
    "partnership": "代理合作",
    "education": "学历教育",
    "news": "新闻动态",
    "contact": "联系"
  },
  "footer": {
    "copyright": "© 2026 Pacific Link International. All rights reserved.",
    "abn": "Australia · ABN 99 673 671 184",
    "quickLinks": "快捷链接",
    "immigrationSite": "移民项目",
    "educationSite": "在线学位项目",
    "legal": "法律信息",
    "legalNotice": "法律声明",
    "privacyPolicy": "隐私政策",
    "termsOfUse": "使用条款"
  }
}
